import type { ReactNode } from "react";
import { Navigate } from "react-router";
import { useSession } from "../../app/session.js";
import { Spinner } from "../../ui/index.js";

/** Этап 7: наша админка: салоны, Instagram, подписка, расход, тревоги, вход в салон с журналом. */
export { AdminCabinetLayout } from "./AdminCabinetLayout.js";
export { AdminSalonPage } from "./AdminSalonPage.js";
export { AdminSalonsPage } from "./AdminSalonsPage.js";

/** Только для адресов из ADMIN_EMAILS; права ещё раз проверяет сервер (`adminProcedure`). */
export function RequireAdmin({ children }: { children: ReactNode }) {
  const session = useSession();
  if (session.loading) return <Spinner />;
  if (!session.user) return <Navigate to="/login?next=%2Fadmin" replace />;
  if (!session.user.isAdmin) return <Navigate to="/" replace />;
  return <>{children}</>;
}
